import type { IconProps } from '@src/components/icons/IconProps';

/** Two people — an in-person meetup. */
export function UsersIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="9" cy="8.5" r="3" />
      <path d="M4 19.5c1.1-2.8 2.8-4 5-4s3.9 1.2 5 4" />
      <circle cx="16.5" cy="9" r="2.5" />
      <path d="M14 19.5c.8-2.2 2.4-3.5 4.5-3.5 1.4 0 2.6.5 3.5 1.8" />
    </svg>
  );
}
